import React, { useState, useEffect } from 'react';
import { Route } from 'react-router';
import OpinionSiteWidget from "./OpinionSiteWidget";
import { opiniones } from "../data";

const OpinionSite = props => {
    const [opinion, setOpinion] = useState(null);

    useEffect(() => {
        const id = props.match.params.id
        if (id) {
            const key = id.toLowerCase();
            const opinion = opiniones[key];
            if (opinion) {
                setOpinion(opinion);
            } else {
                props.history.push("/");
            }
        } else {
            props.history.push("/");
        }
    });

    return (
        <Route {...props}>
            <div>
                <div>
                    {opinion && < OpinionSiteWidget opinion={opinion} key={props.match.params.id}/>}
                </div>
            </div >
        </Route>
        );
}

export default OpinionSite;
